import { PageContent, Box, Header, Heading, Paragraph } from "grommet";
import { PropsWithChildren } from "react";
import { AppPage } from "../components/app-page";
import React from "react";
import Rings from "../images/rings.png";
import { CaseyImage } from "../components/casey-image";

const Schedule: React.FC<PropsWithChildren> = () => {
    return (
        <AppPage>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'orange' }}>
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "xlarge" }}>
                        <Header direction="column" gap="small" overflow="hidden" className="title-medium">
                            <Heading weight="normal" margin="none" color="charcoal">schedule</Heading>
                        </Header>
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'charcoal' }}>
                    <Box align="center" pad="large">

                        <Box align="center" pad="medium">
                            <Heading weight="normal" size="70px" margin="none">wednesday</Heading>
                            <Paragraph color="green_foreground" textAlign="center">
                                4:30 PM - Check in
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                7:30 PM - Dinner - burgers + dogs
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                10:00 PM - Quiet hours
                            </Paragraph>
                        </Box>
                        <Box align="center" pad="medium">
                            <Heading weight="normal" size="70px" margin="none">thursday</Heading>
                            <Paragraph color="green_foreground" textAlign="center">
                                9:30 AM - Breakfast + morning announcements
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                12:30 PM - Lunch
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                6:00 PM - Dinner - pasta
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                8:00 PM - Dominoes
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                10:00 PM - Quiet hours
                            </Paragraph>
                        </Box>
                        <Box align="center" pad="medium">
                            <Heading weight="normal" size="70px" margin="none">friday</Heading>
                            <Paragraph color="green_foreground" textAlign="center">
                                9:30 AM - Breakfast + morning announcements
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                12:30 PM - Lunch
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                6:00 PM - Dinner - Indian food
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                8:00 PM - Bingo
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                10:00 PM - Quiet hours
                            </Paragraph>
                        </Box>
                        <Box align="center" pad="medium">
                            <Heading weight="normal" size="70px" margin="none">saturday</Heading>
                            <Paragraph color="green_foreground" textAlign="center">
                                9:30 AM - Breakfast + morning announcements
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                12:30 PM - Lunch
                            </Paragraph>
                            <CaseyImage
                                src={Rings}
                                style={{ width: "100px" }}
                                alignSelf="center"
                                margin="xsmall"
                            />

                            <Paragraph color="green_foreground" textAlign="center">
                                <strong>4:00 PM - The Marriage</strong>

                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                5:00 PM - Lawn games + chit chat
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                6:30 PM - Dinner
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                7:30 PM - The Unveiling of the Knobs
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                8:00 PM - Bonfire
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                10:00 PM - Quiet hours
                            </Paragraph>
                        </Box>
                        <Box align="center" pad="medium">
                            <Heading weight="normal" size="70px" margin="none">sunday</Heading>
                            <Paragraph color="green_foreground" textAlign="center">
                                10:00 AM - Brunch
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                11:00 PM - Clean!
                            </Paragraph>
                            <Paragraph color="green_foreground" textAlign="center">
                                1:30 PM - Check out
                            </Paragraph>
                        </Box>
                    </Box>
                </PageContent>
        </AppPage>
    );
}

export default Schedule;
